/*!
 * Moikka Art Wall Designer — Shopify Bridge v1.0
 *
 * INSTALLATION (Shopify theme):
 *   1. Copy this file to your theme's assets folder as "art-wall-bridge.js"
 *   2. Add this line inside <head> in theme.liquid (or layout/theme.liquid):
 *        {{ 'art-wall-bridge.js' | asset_url | script_tag }}
 *
 * What it does:
 *   Listens for postMessage events from the Art Wall Designer iframe and
 *   syncs items into the customer's live Shopify session cart via the
 *   AJAX Cart API — so cart count, drawer, and header all update normally.
 */
(function () {
  'use strict';

  var SOURCE_PROP = '_source';
  var SOURCE_VALUE = 'art-wall-designer';

  var ALLOWED_ORIGINS = [
    'https://moikka-art-wall.vercel.app',
    'http://localhost:5173',
    'http://localhost:4173',
  ];

  function isAllowedOrigin(origin) {
    if (!origin) return false;
    return ALLOWED_ORIGINS.indexOf(origin) !== -1;
  }

  window.addEventListener('message', function (event) {
    var data = event.data;
    if (!data || typeof data !== 'object' || !data._awdId) return;
    if (data.type === 'AWD_SYNC_CART') {
      if (!isAllowedOrigin(event.origin)) return;
      handleSyncCart(event.source, event.origin, data);
    } else if (data.type === 'AWD_GOTO_CHECKOUT') {
      if (!isAllowedOrigin(event.origin)) return;
      // Navigate the parent page to the given path (e.g. /cart or /checkout)
      window.location.href = data.path || '/cart';
      // No reply needed; page navigates away
    } else if (data.type === 'AWD_GET_CART_STATE') {
      if (!isAllowedOrigin(event.origin)) return;
      handleGetCartState(event.source, event.origin, data);
    }
  });

  function handleSyncCart(source, origin, data) {
    var items = data.items || [];
    if (items.length === 0) {
      source.postMessage({ _awdId: data._awdId, success: true, cartCount: 0 }, origin || '*');
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        source.postMessage({
          _awdId: data._awdId,
          success: true,
          cartCount: cart.item_count,
        }, origin || '*');
      })
      .catch(function (err) {
        source.postMessage({
          _awdId: data._awdId,
          success: false,
          error: err.message || 'Unknown error',
        }, origin || '*');
      });
  }

  function handleGetCartState(source, origin, data) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = [];
        (cart.items || []).forEach(function (item) {
          var props = item.properties || {};
          if (props[SOURCE_PROP] !== SOURCE_VALUE) return;
          if (props['_awdProjectId'] !== data.projectId) return;
          if (props['_awdWallId'] !== data.wallId) return;
          if (!props['_placedItemId'] || !props['_itemType']) return;
          lines.push({
            placedItemId: props['_placedItemId'],
            itemType:     props['_itemType'],
            variantId:    item.variant_id,
          });
        });
        source.postMessage({ _awdId: data._awdId, success: true, lines: lines }, origin || '*');
      })
      .catch(function (err) {
        source.postMessage({ _awdId: data._awdId, success: false, error: err.message || 'Unknown error', lines: [] }, origin || '*');
      });
  }
})();
